module.exports = __webpack_public_path__ + "static/Lasting_Partnership-f27db8fc36e3db18df9102a0696ffd4e.png";